import * as React from 'react'

function SvgIllustrationEmpty(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg viewBox="0 0 80 50" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h80v50H0z" />
        <g transform="translate(9 2)">
          <ellipse fill="#EAEEF4" cx={30.882} cy={41.176} rx={30.882} ry={6.176} />
          <g transform="translate(14)" stroke="#98A6B8">
            <rect
              strokeWidth={0.6}
              fill="#FFF"
              x={0.3}
              y={0.3}
              width={32.753}
              height={41.4}
              rx={2}
            />
            <path d="M7 18.618h19.134M7 11.5h7.338M6.877 24.784h19.134" />
          </g>
          <path
            d="M40.213 35.43v2.015c0 1.3.51 2.48 1.341 3.35.34.356.732.66 1.165.9h0l-28.713.005a3.688 3.688 0 01-2.616-1.084A3.688 3.688 0 0110.306 38h0v-2.57h29.907z"
            stroke="#98A6B8"
            strokeWidth={0.6}
            fill="#FFF"
          />
          <g transform="rotate(19 -27.29 139.917)" stroke="#98A6B8" strokeWidth={0.6}>
            <path
              d="M23.31 14.661a1.9 1.9 0 01.887 1.157 1.9 1.9 0 01-.19 1.447 1.9 1.9 0 01-1.158.888 1.9 1.9 0 01-1.446-.19h0l-8.188-4.728a1.9 1.9 0 01-.888-1.157 1.9 1.9 0 01.19-1.447 1.9 1.9 0 011.158-.888 1.9 1.9 0 011.446.19h0z"
              fill="#98A6B8"
            />
            <circle fill="#FFF" cx={7.924} cy={7.924} r={7.624} />
            <circle fill="#FFF" cx={7.924} cy={7.924} r={5.186} />
          </g>
        </g>
      </g>
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgIllustrationEmpty)
const MemoForwardRef = React.memo(ForwardRef)
export default MemoForwardRef
